import CryptoJS from 'crypto-js';
import Cookies from 'js-cookie';

export const Encrypt = (text, path) => {
  localStorage.removeItem(path);
  sessionStorage.removeItem(path);
  const textToChars = (text) => text.split('').map((c) => c.charCodeAt(0));
  const byteHex = (n) => ('0' + Number(n).toString(16)).substr(-2);
  const applySaltToChar = (code) =>
    textToChars('subpath').reduce((a, b) => a ^ b, code);
  let encriptString = text
    ? text.split('').map(textToChars).map(applySaltToChar).map(byteHex).join('')
    : '';
  localStorage.setItem(path, encriptString);
  if (path === 'selectCountryId' || path === 'selectCountry') {
    sessionStorage.setItem(path, encriptString);
    if (text) {
      Cookies.set(path, text, { expires: 3 });
    } else {
      Cookies.remove(path);
    }
  }
};

export const decrypt = (path) => {
  let encoded = '';

  if (path === 'selectCountryId' || path === 'selectCountry') {
    encoded = sessionStorage.getItem(path) ?? localStorage.getItem(path);
  } else {
    encoded = localStorage.getItem(path);
  }

  if (encoded) {
    const textToChars = (text) => text.split('').map((c) => c.charCodeAt(0));
    const applySaltToChar = (code) =>
      textToChars('subpath').reduce((a, b) => a ^ b, code);

    const hexPairs = encoded.match(/.{1,2}/g);
    if (hexPairs) {
      try {
        const decrypted = hexPairs
          .map((hex) => parseInt(hex, 16))
          .map(applySaltToChar)
          .map((charCode) => String.fromCharCode(charCode))
          .join('')
          .replace(/[\u0000-\u001F]+/g, '');
        if (decrypted) return decrypted;
      } catch (e) {
        // Fallback to cookie below
      }
    }
  }

  if (path === 'selectCountryId' || path === 'selectCountry') {
    const cookieVal = Cookies.get(path);
    if (cookieVal) {
      return cookieVal;
    }
  }

  return null;
};

export const EncryptGlobal = (text, path) => {
  localStorage.removeItem(path);
  const textToChars = (text) => text.split('').map((c) => c.charCodeAt(0));
  const byteHex = (n) => ('0' + Number(n).toString(16)).substr(-2);
  const applySaltToChar = (code) =>
    textToChars('subpath').reduce((a, b) => a ^ b, code);
  let encriptString = text
    .split('')
    .map(textToChars)
    .map(applySaltToChar)
    .map(byteHex)
    .join('');
  localStorage.setItem(path, encriptString);
};

export const decryptGlobal = (path) => {
  let encoded = localStorage.getItem(path);

  if (encoded) {
    const textToChars = (text) => text.split('').map((c) => c.charCodeAt(0));
    const applySaltToChar = (code) =>
      textToChars('subpath').reduce((a, b) => a ^ b, code);

    const hexPairs = encoded.match(/.{1,2}/g);
    if (!hexPairs) return null;

    return hexPairs
      .map((hex) => parseInt(hex, 16))
      .map(applySaltToChar)
      .map((charCode) => String.fromCharCode(charCode))
      .join('')
      .replace(/[\u0000-\u001F]+/g, '');
  }

  return null;
};

const secretKey = process.env.REACT_APP_SECRET_KEY;

/** Base64 -> Base64URL (safe for URL path segments) */
function toBase64Url(b64) {
  return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
}

export function encryptParams(params) {
  if (!secretKey) {
    console.error('REACT_APP_SECRET_KEY is not set');
    return '';
  }

  const stringParams = new URLSearchParams(
    Object.entries(params).map(([k, v]) => [k, String(v)])
  ).toString();

  const encryptedBase64 = CryptoJS.AES.encrypt(
    stringParams,
    secretKey
  ).toString();

  // Return URL-safe token (no / + =)
  return toBase64Url(encryptedBase64);
}
